const newPasswordChallengeCognito = (
  newPassword,
  challengeUserAttributes,
  cognitoUser
) => {
  return new Promise((resolve, reject) => {
    try {
      cognitoUser.completeNewPasswordChallenge(
        newPassword,
        challengeUserAttributes
      );
      resolve();
    } catch (err) {
      reject(err.message || JSON.stringify(err));
    }
  });
};

export default newPasswordChallengeCognito;
